import React from 'react';
import { Link } from 'react-router-dom';
import Logo  from '../images/logo.png'

export const Error = () => {

    return (
        <>
           <div className="layout-topbar">
				<div className="topbar-left">
					<div className="layout-breadcrumb">
						<Link to="/" className="logo">
							<div className="flex align-content-center flex-wrap">
								<div className="logos">
									<img src={Logo} />
								</div>
								<div className="ml-2 logoText flex align-items-center justify-content-center">
									CURRY ROCKEFELLER GROUP
								</div>
							</div>
						</Link>
					</div>
					
				</div>
			</div>
			<div className="exception-body error">
				<div className="exception-content">
					<div className="exception-title">ERROR</div>
					<div className="exception-detail">Something went wrong.</div>
					<Link to="/">Go to Dashboard</Link>
				</div>
			</div>
		</>
    );
}
